// extracted by mini-css-extract-plugin
export default {"slider_container":"why-card_slider_container__82+wY"};